import { RecordBaseItem } from "./record-base.item";
import { AthleteGeneralInfoItem } from "./athlete-general-info.item";

export class RecordHistoryItem extends RecordBaseItem {
  athletes: Array<AthleteGeneralInfoItem> | AthleteGeneralInfoItem;
  date: Date;
  getLabel(): string {
    return "";
  }

  getPicture(): string {
    return "";
  }

  getSubjectId(): any {
    return "";
  }
  constructor(rawItem, factoryService) {
    super(rawItem, factoryService);

    // Obtain individual athlete info.
    let archer = rawItem.Archers;
    this.date = new Date(
      new Date(
        new Date(rawItem.Date).getTime() +
          Math.abs(new Date(rawItem.Date).getTimezoneOffset() * 60000)
      )
    );
    // Archer object has no NOC, add it from the record object.
    archer.NOC = rawItem.NOC;

    if (archer instanceof Array) {
      this.athletes = [];
      archer.forEach(value => {
        (<Array<AthleteGeneralInfoItem>>this.athletes).push(
          this.factory.newAthleteGeneralInfoItem(value)
        );
      });
    } else {
      this.athletes = this.factory.newAthleteGeneralInfoItem(archer);
    }
  }
}
